import _regeneratorRuntime from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _defineProperty from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _objectSpread from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Source\\SysDem\\04. SysDem.Go\\SysDem.Go.APIandWeb\\src\\frontend\\DemOffice-UI-develop\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { AbortController } from "./AbortController";
import { HttpError, TimeoutError } from "./Errors";
import { LogLevel } from "./ILogger";
import { TransferFormat } from "./ITransport";
import { Arg, getDataDetail, getUserAgentHeader, sendMessage } from "./Utils"; // Not exported from 'index', this type is internal.

/** @private */

export var LongPollingTransport =
/*#__PURE__*/
function () {
  function LongPollingTransport(httpClient, logger, options) {
    _classCallCheck(this, LongPollingTransport);

    this._httpClient = httpClient;
    this._logger = logger;
    this._pollAbort = new AbortController();
    this._options = options;
    this._running = false;
    this.onreceive = null;
    this.onclose = null;
  } // This is an internal type, not exported from 'index' so this is really just internal.


  _createClass(LongPollingTransport, [{
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(url, transferFormat) {
        var _getUserAgentHeader, _getUserAgentHeader2, name, value, headers, pollOptions, pollUrl, response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Arg.isRequired(url, "url");
                Arg.isRequired(transferFormat, "transferFormat");
                Arg.isIn(transferFormat, TransferFormat, "transferFormat");
                this._url = url;

                this._logger.log(LogLevel.Trace, "(LongPolling transport) Connecting."); // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)


                if (!(transferFormat === TransferFormat.Binary && typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
                  _context.next = 7;
                  break;
                }

                throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");

              case 7:
                _getUserAgentHeader = getUserAgentHeader(), _getUserAgentHeader2 = _slicedToArray(_getUserAgentHeader, 2), name = _getUserAgentHeader2[0], value = _getUserAgentHeader2[1];
                headers = _objectSpread(_defineProperty({}, name, value), this._options.headers);
                pollOptions = {
                  abortSignal: this._pollAbort.signal,
                  headers: headers,
                  timeout: 100000,
                  withCredentials: this._options.withCredentials
                };

                if (transferFormat === TransferFormat.Binary) {
                  pollOptions.responseType = "arraybuffer";
                } // Make initial long polling request
                // Server uses first long polling request to finish initializing connection and it returns without data


                pollUrl = "".concat(url, "&_=").concat(Date.now());

                this._logger.log(LogLevel.Trace, "(LongPolling transport) polling: ".concat(pollUrl, "."));

                _context.next = 15;
                return this._httpClient.get(pollUrl, pollOptions);

              case 15:
                response = _context.sent;

                if (response.statusCode !== 200) {
                  this._logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: ".concat(response.statusCode, ".")); // Mark running as false so that the poll immediately ends and runs the close logic


                  this._closeError = new HttpError(response.statusText || "", response.statusCode);
                  this._running = false;
                } else {
                  this._running = true;
                }

                this._receiving = this._poll(this._url, pollOptions);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connect(_x, _x2) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
  }, {
    key: "_poll",
    value: function () {
      var _poll2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(url, pollOptions) {
        var pollUrl, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

              case 1:
                if (!this._running) {
                  _context2.next = 16;
                  break;
                }

                _context2.prev = 2;
                pollUrl = "".concat(url, "&_=").concat(Date.now());

                this._logger.log(LogLevel.Trace, "(LongPolling transport) polling: ".concat(pollUrl, "."));

                _context2.next = 7;
                return this._httpClient.get(pollUrl, pollOptions);

              case 7:
                response = _context2.sent;

                if (response.statusCode === 204) {
                  this._logger.log(LogLevel.Information, "(LongPolling transport) Poll terminated by server.");

                  this._running = false;
                } else if (response.statusCode !== 200) {
                  this._logger.log(LogLevel.Error, "(LongPolling transport) Unexpected response code: ".concat(response.statusCode, ".")); // Unexpected status code


                  this._closeError = new HttpError(response.statusText || "", response.statusCode);
                  this._running = false;
                } else {
                  // Process the response
                  if (response.content) {
                    this._logger.log(LogLevel.Trace, "(LongPolling transport) data received. ".concat(getDataDetail(response.content, this._options.logMessageContent), "."));

                    if (this.onreceive) {
                      this.onreceive(response.content);
                    }
                  } else {
                    // This is another way timeout manifest.
                    this._logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                  }
                }

                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);

                if (!this._running) {
                  // Log but disregard errors that occur after stopping
                  this._logger.log(LogLevel.Trace, "(LongPolling transport) Poll errored after shutdown: ".concat(_context2.t0.message));
                } else {
                  if (_context2.t0 instanceof TimeoutError) {
                    // Ignore timeouts and reissue the poll.
                    this._logger.log(LogLevel.Trace, "(LongPolling transport) Poll timed out, reissuing.");
                  } else {
                    // Close the connection with the error as the result.
                    this._closeError = _context2.t0;
                    this._running = false;
                  }
                }

              case 14:
                _context2.next = 1;
                break;

              case 16:
                _context2.prev = 16;

                this._logger.log(LogLevel.Trace, "(LongPolling transport) Polling complete."); // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
                // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.


                if (!this.pollAborted) {
                  this._raiseOnClose();
                }

                return _context2.finish(16);

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0,, 16, 20], [2, 11]]);
      }));

      function _poll(_x3, _x4) {
        return _poll2.apply(this, arguments);
      }

      return _poll;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(data) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this._running) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", Promise.reject(new Error("Cannot send until the transport is connected")));

              case 2:
                return _context3.abrupt("return", sendMessage(this._logger, "LongPolling", this._httpClient, this._url, data, this._options));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function send(_x5) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var headers, _getUserAgentHeader3, _getUserAgentHeader4, name, value, deleteOptions;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this._logger.log(LogLevel.Trace, "(LongPolling transport) Stopping polling."); // Tell receiving loop to stop, abort any current request, and then wait for it to finish


                this._running = false;

                this._pollAbort.abort();

                _context4.prev = 3;
                _context4.next = 6;
                return this._receiving;

              case 6:
                // Send DELETE to clean up long polling on the server
                this._logger.log(LogLevel.Trace, "(LongPolling transport) sending DELETE request to ".concat(this._url, "."));

                headers = {};
                _getUserAgentHeader3 = getUserAgentHeader(), _getUserAgentHeader4 = _slicedToArray(_getUserAgentHeader3, 2), name = _getUserAgentHeader4[0], value = _getUserAgentHeader4[1];
                headers[name] = value;
                deleteOptions = {
                  headers: _objectSpread({}, headers, this._options.headers),
                  timeout: this._options.timeout,
                  withCredentials: this._options.withCredentials
                };
                _context4.next = 13;
                return this._httpClient.delete(this._url, deleteOptions);

              case 13:
                this._logger.log(LogLevel.Trace, "(LongPolling transport) DELETE request sent.");

              case 14:
                _context4.prev = 14;

                this._logger.log(LogLevel.Trace, "(LongPolling transport) Stop finished."); // Raise close event here instead of in polling
                // It needs to happen after the DELETE request is sent


                this._raiseOnClose();

                return _context4.finish(14);

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[3,, 14, 18]]);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
  }, {
    key: "_raiseOnClose",
    value: function _raiseOnClose() {
      if (this.onclose) {
        var logMessage = "(LongPolling transport) Firing onclose event.";

        if (this._closeError) {
          logMessage += " Error: " + this._closeError;
        }

        this._logger.log(LogLevel.Trace, logMessage);

        this.onclose(this._closeError);
      }
    }
  }, {
    key: "pollAborted",
    get: function get() {
      return this._pollAbort.aborted;
    }
  }]);

  return LongPollingTransport;
}();